import { HttpStatus } from 'ha/constants/HttpStatus';
import { ErrorMessages } from 'ha/constants/ErrorMessages';
import { changeLocation } from 'ha/modules/URLLocationHandler';
import {
  ApiV2ErrorCodes,
  ErrorResponse,
  RequestError,
} from '@ha/api/v2/errors';
import { Thunk } from 'ha/myredux/types';
import { Payload as LoginPayload } from '@ha/api/v2/login';
import { GlobalState } from 'ha/types/store';
import { updateHasEverLoggedIn } from 'ha/server/routers/ha/googleOptimize';

import { AuthType } from '../types';
import { AuthLogicActions } from './actions';
import { login } from './login';

function requiresPasswordChange(errorResponse: ErrorResponse | undefined) {
  return errorResponse?.errors?.some(
    error => error.code === ApiV2ErrorCodes._password_change_required,
  );
}

export const loginRequest =
  (fields: LoginPayload, nextUrl?: string): Thunk<GlobalState, void> =>
  (dispatch, _, services) => {
    dispatch(AuthLogicActions.authStart());

    return services.apiV2
      .login(fields)
      .then(({ data }) => {
        updateHasEverLoggedIn();
        if (nextUrl) {
          // if redirect is happening, avoid unnecessary page rerendering by modifying auth state
          // it can also lead to error in firefox
          // (network requests done during redirect are aborted with an error, breaking loadable components)
          return dispatch(changeLocation(nextUrl));
        }

        dispatch(AuthLogicActions.authDone());

        return dispatch(login(data, AuthType.login));
      })
      .catch((err: RequestError) => {
        dispatch(AuthLogicActions.authFail());

        if (err.status === HttpStatus.FORBIDDEN) {
          if (requiresPasswordChange(err.response)) {
            return dispatch(
              changeLocation('/recover-account?reason=account-locked'),
            );
          }

          throw new Error(ErrorMessages.emailOrPasswordIncorrect);
        } else if (err.status === HttpStatus.SERVICE_UNAVAILABLE) {
          throw new Error(ErrorMessages.maxAttemptsReached);
        }

        throw err;
      });
  };
